import * as types from "./mutation-type";
import { getStoresQuery } from "./queries.graphql";
import gqlClient from "@/modules/graphql";
import api from "@/modules/api";

const actions = {
  async getStores({ commit }, variables = {}) {
    try {
      commit(types.GET_STORES_BEGIN);
      const {
        data: {
          data: {
            company: { stores }
          }
        }
      } = await gqlClient.query({
        query     : getStoresQuery,
        variables : variables
      });
      commit(types.GET_STORES_SUCCESS, stores);
    } catch (e) {
      commit(types.GET_STORES_ERROR, e);
    }
  },
  async deleteStore({ commit }, id) {
    try {
      commit(types.DELETE_STORE_BEGIN);
      await api.companyStore.deleteStore(id);
      commit(types.DELETE_STORE_SUCCESS, id);
    } catch (e) {
      commit(types.DELETE_STORE_ERROR, e);
    }
  },
};
export default actions;
